import FieldOptionDialogController from './controller/FieldOptionDialogController.js'
const template = require('./fieldOptionDialog.tpl.pug')

const optionsGroupDialog = {
  parent: angular.element(document.body),
  template: template(),
  clickOutsideToClose: false,
  fullscreen: false,
  bindToController: true,
  controllerAs: '$ctrl',
  controller: FieldOptionDialogController,
}

export default optionsGroupDialog

